'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('.');

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticMap = function (_Component) {
  (0, _inherits3.default)(StaticMap, _Component);

  function StaticMap() {
    (0, _classCallCheck3.default)(this, StaticMap);
    return (0, _possibleConstructorReturn3.default)(this, (StaticMap.__proto__ || (0, _getPrototypeOf2.default)(StaticMap)).apply(this, arguments));
  }

  (0, _createClass3.default)(StaticMap, [{
    key: 'render',
    value: function render() {
      var params = {
        center: this.props.latitude + ',' + this.props.longitude,
        key: this.props.apiKey,
        zoom: this.props.zoom,
        scale: this.props.scale,
        size: this.props.width + 'x' + this.props.height,
        maptype: 'roadmap'
      };
      var paramsArray = [];
      (0, _keys2.default)(params).map(function (param) {
        return paramsArray.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
      });
      var paramsString = paramsArray.join('&');
      var latlong = this.props.latitude + ',' + this.props.longitude;
      var directionsURL = 'http://www.google.com/maps/place/' + latlong + '/@' + latlong + ',15z';
      var style = { paddingBottom: this.props.height / this.props.width * 100 + '%' };

      return _react2.default.createElement(
        'div',
        { className: 'StaticMap' },
        _react2.default.createElement(
          'a',
          { target: '_blank', rel: 'noopener noreferrer', href: directionsURL, style: style },
          _react2.default.createElement('img', { src: 'https://maps.googleapis.com/maps/api/staticmap?' + paramsString, alt: (0, _i18n2.default)('venueMap') }),
          _react2.default.createElement(_.MapMarker, null)
        )
      );
    }
  }]);
  return StaticMap;
}(_react.Component);

StaticMap.propTypes = {
  /**
   * The Google Static Maps API key.
   */
  apiKey: _propTypes2.default.string.isRequired,
  /**
   * The height of the map.
   */
  height: _propTypes2.default.number,
  /**
   * The latitude of the map marker.
   */
  latitude: _propTypes2.default.string.isRequired,
  /**
   * The longitude of the map marker.
   */
  longitude: _propTypes2.default.string.isRequired,
  /**
   * The scale of the map.
   */
  scale: _propTypes2.default.number,
  /**
   * The width of the map.
   */
  width: _propTypes2.default.number,
  /**
   * The zoom level of the map.
   */
  zoom: _propTypes2.default.number
};
StaticMap.defaultProps = {
  height: 170,
  scale: 2,
  width: 350,
  zoom: 14
};
exports.default = StaticMap;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/StaticMap.js
// module id = 287
// module chunks = 0